module.exports = __webpack_public_path__ + "media/newstyle/images/icon-search-purple-orange-29087e5cf9d33f1e82e9dce31fb30f7e.svg";